import loadable from '../../utilities/loadable'

export const CounterOffer = loadable(() => import('./CounterOffer'))
export const EditLocationAllocationModal = loadable(() =>
  import('./EditLocationAllocationModal')
)
